import '../../css/appointments_page.css';
import Header from '../Header/Header';
import ViewStaffAppointments from './ViewStaffAppointmentsComponent';

export default function StaffAppointmentsPage() {
    return (
        <div className="min-h-screen bg-[#edeef2]">
            <header className="fixed top-0 left-0 z-50 h-[70px] w-full bg-white border-b border-gray-200 shadow-sm">
                <Header />
            </header>

            <main
                className={`
                    pt-[70px]
                    transition-all duration-300
                    h-full
                `}
            >
                <ViewStaffAppointments />
            </main>
        </div>
    );
}